import React, { useState, useEffect, useRef } from 'react';

import InputField from '../inputField/InputField';
import Loader from '../loader/Loader';
import { useTranslation } from 'react-i18next';

import './SearchableDealerList.scss';

export type DropdownOptionType = {
    label: string;
    value: string;
};

export type SearchableDealerListProps = {
    isLoading?: boolean;
    label?: string;
    onQueryChange?: (param) => void;
    options: DropdownOptionType[];
    searchPlaceholder?: string;
    totalDealers: number;
    onClick,
};

const SearchableDealerList = ({
    isLoading = false,
    label,
    totalDealers,
    onQueryChange,
    options,
    searchPlaceholder,
    onClick
}: SearchableDealerListProps) => {
    const { t } = useTranslation();

    const [filterQuery, setFilterQuery] = useState('');
    const [filteredOptions, setFilteredOptions] = useState<any>([]);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setFilteredOptions(options);
    }, [options]);

    const handleFiltering = (event: React.ChangeEvent<HTMLInputElement>) => {
        /**
         * We do not allow changing the query if async request is on-flight
         */
        if (isLoading) return;
        event.persist();

        const query = event.target.value;

        setFilterQuery(query);

        if (onQueryChange) {
            return onQueryChange(event.target.value);
        }
    };

    return (
        <div className="b-searchable-list" ref={dropdownRef}>
            <div className="list-menu">
                {isLoading && <Loader />}
                {totalDealers === 0 && (
                    <span className="no-dealers">
                        {t('no_dealers_affiliated')}
                    </span>
                )}
                {totalDealers > 25 && (
                    <>
                        <span className="count-warning">
                            {t('narrow_options')}
                        </span>
                        <InputField
                            inputType="text"
                            isFocusDisabled
                            label={searchPlaceholder || label}
                            name='search-dealers'
                            onChangeHandler={handleFiltering}
                            value={filterQuery}
                            autoFocus
                        />
                    </>
                )}
                {!isLoading && totalDealers > 0 && filteredOptions.length === 0 && (
                    <span className="no-result">{t('no_result')}</span>
                )}
                {!isLoading && totalDealers > 0 && filteredOptions.length > 0 && (
                    <ul className='dealers-list'>
                        {filteredOptions.map((dealer, i) => (
                            <li className='dealer' key={dealer.kvps} onClick={() => onClick(dealer)} data-testid={`dealer-item-${i + 1}`}>{dealer.title}</li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default SearchableDealerList;
